import React from "react";
import ReactDOM from "react-dom";
import Notice from "../../contracts/Notice.json";
import Web3 from "web3";

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import {
  Row,
  Card,
  Button,
  ListGroup,
  ListGroupItem,
  Col,
} from "react-bootstrap";

export default class Listener extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Notices: [],
    };
  }
  componentDidMount() {
    const Notices_display = localStorage.getItem("Notices");
    const notes = JSON.parse(Notices_display);
    console.log(notes);
    this.setState({ Notices: notes });
    console.log(this.state.Notices);
  }

  // async listen(fromBlockNumber) {
  //   console.log("Listening for events");
  //   const web3 = new Web3(Web3.givenProvider || "http://localhost:8545");
  //   const accounts = await web3.eth.getAccounts();
  //   const networkId = await web3.eth.net.getId();
  //   const deployedNetwork = Notice.networks[networkId];
  //   const instance = new web3.eth.Contract(
  //     Notice.abi,
  //     deployedNetwork && deployedNetwork.address
  //   );
  //   instance.events.emitnotice(
  //     {
  //       fromBlock: fromBlockNumber,
  //     },
  //     (err, contractEvent) => {
  //       if (err) {
  //         console.error("listener error", err);
  //         return;
  //       }
  //       console.log("Heard something!");
  //       console.log("this is from the listener script");
  //       const { event, returnValues, blockNumber } = contractEvent;
  //       const {
  //         hospital_name,
  //         hospital_address,
  //         date,
  //         cylinders,
  //         vaccine_doses,
  //         ventilators,
  //         icu,
  //       } = returnValues;

  //       this.setState({
  //         hospital_name: hospital_name,
  //         hospital_address: hospital_address,
  //         date: date,
  //         cylinders: cylinders,
  //         vaccine_doses: vaccine_doses,
  //         ventilators: ventilators,
  //         icu: icu,
  //       });

  //       const data = {
  //         hp_name: this.state.hospital_name,
  //         hp_add: this.state.hospital_address,
  //       };

  //       this.setState({
  //         Notices: [...this.state.Notices, data],
  //       });

  //       console.log(
  //         `${event}: At block ${blockNumber} there is a notice from ${hospital_name} at ${hospital_address} where there are ${cylinders} oxygen cylinders, ${vaccine_doses} vaccine doses, ${ventilators} ventilators and ${icu} icu's at ${date}`
  //       );
  //     }
  //   );
  // }

  render() {
    return (
      <div className="container container-fluid login-conatiner">
        <div style={{ padding: "5px" }}>
          <div className="d-flex flex-row btn btn-dark btn-lg btn-block">
            <Link to="/patient/home">
              <Button variant="secondary">Home</Button>
            </Link>{" "}
            <h3 style={{ color: "white", marginLeft: "430px" }}>ALL NOTICES</h3>
            <Link style={{ color: "white", marginLeft: "460px" }} to="/logout">
              <Button variant="secondary">Logout</Button>
            </Link>{" "}
          </div>
        </div>
        <div className="container">
          {this.state.Notices.map((note) => (
            <div key={note.id}>
              <Card
                className="text-center"
                style={{
                  marginTop: "30px",
                  marginBottom: "40px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "400px",
                  boxShadow: "0px 4px 10px",
                }}
              >
                <Card.Header></Card.Header>
                <Card.Body>
                  <Card.Title>{note.hp_name}</Card.Title>
                  <Card.Text>{note.hp_add}</Card.Text>
                  <ListGroup className="list-group-flush">
                    <ListGroupItem>ICU : {note.icu}</ListGroupItem>
                    <ListGroupItem>
                      VENTILATORS : {note.ventilators}
                    </ListGroupItem>
                    <ListGroupItem>
                      OXYGEN CYLINDERS : {note.oxy_cylinders}
                    </ListGroupItem>
                    <ListGroupItem>
                      VACCINE DOSES : {note.vaccine_doses}
                    </ListGroupItem>
                  </ListGroup>
                 
                </Card.Body>
                <Card.Footer className="text-muted"></Card.Footer>
              </Card>

              <br></br>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
